import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { RouteContainer } from './RouteContainer';
import { CommandPalette } from '@shared/components/CommandPalette';
import { ConfirmProvider } from '@shared/components/ConfirmDialog';
import { ShortcutSheet } from '@shared/components/ShortcutSheet';
import { useUiStore } from '@shared/stores/uiStore';
import { useGlobalShortcuts } from '@shared/hooks/useGlobalShortcuts';
import { RouteProgress } from './RouteProgress';
import { ForcePasswordResetGate } from '@features/auth/components/ForcePasswordResetGate';
import { useTranslation } from 'react-i18next';

export function AppShell() {
  const { t } = useTranslation('app');
  useGlobalShortcuts();
  const open = useUiStore((s) => s.commandPaletteOpen);
  const setOpen = useUiStore((s) => s.setCommandPaletteOpen);

  return (
    <ConfirmProvider>
      <div className="app-shell">
        <a className="ds-skip-link" href="#main-content">
          {t('shell.skipToContent')}
        </a>
        <Sidebar />
        <div className="app-shell__main">
          <RouteProgress />
          <Topbar />
          <main id="main-content" className="app-shell__content" role="main" tabIndex={-1}>
            <RouteContainer>
              <Outlet />
            </RouteContainer>
          </main>
        </div>
        <CommandPalette open={open} onClose={() => setOpen(false)} />
        <ShortcutSheet />
        <ForcePasswordResetGate />
      </div>
    </ConfirmProvider>
  );
}
